import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import {
  fetchOverallData,
} from '../redux/PerformanceReducer/Overall/overallSlice';
import { selectIsMultiStoreEnabled, selectUserDetails } from '../redux/UserReducer/userSlice';
import { getEffectiveStoreNumber } from '../utils/appUtils';

export const useOverallPerformanceGraphData = (): void => {
  const dispatch = useAppDispatch();
  const userDetails = useAppSelector(selectUserDetails);
  const isMultiStoreEnabled = useAppSelector(selectIsMultiStoreEnabled);

  const effectiveStoreNumber = useMemo(
    () => getEffectiveStoreNumber(userDetails, isMultiStoreEnabled),
    [userDetails, isMultiStoreEnabled]
  );

  useEffect(() => {
    if (!effectiveStoreNumber) return;
    dispatch(fetchOverallData({storeNumber: effectiveStoreNumber, isMultiStoreMode: isMultiStoreEnabled}));
  }, [effectiveStoreNumber, isMultiStoreEnabled, dispatch]);
};
